export const cryptoIcons = {
  "dai-bsc": "/assets/images/cryptos/dai.png",
  "eth-bsc": "/assets/images/cryptos/ethereum.png",
  "zusd-bsc": "/assets/images/cryptos/dai.png",
};

export const AddressZero = "0x0000000000000000000000000000000000000000";
export const MAX_ALLOWANCE_UNIT =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";
